<div class="container">
    <div class="modal__content">
        <form [formGroup]="authForm" *ngIf="authInfo.key !== authenticationPreferences.Custom">
            <div class="modal__input">
                <signaturit-input
                    [inputType]="authInfo.type"
                    [labelName]="authInfo.label"
                    [inputWidth]="216"
                    [placeholderName]="authInfo.placeholder"
                    (outputValue)="setInputValue($event, authInfo.key, authForm)"
                >
                </signaturit-input>
                <mat-error *ngIf="showErrorMessage && authForm.get(authInfo.key)?.hasError('required')">
                    {{ 'form_error_required' | translate }}
                </mat-error>
                <mat-error
                    *ngIf="showErrorMessage && (authForm.get(authInfo.key)?.hasError('nif') || authForm.get(authInfo.key)?.hasError('cif') || authForm.get(authInfo.key)?.hasError('nifnie'))">
                    {{ 'authorization-modal.form_error' | translate }}
                </mat-error>
            </div>
        </form>
        <form [formGroup]="customFieldsForm" *ngIf="authInfo.key === authenticationPreferences.Custom">
            <div class="modal__input" *ngFor="let field of customFields">
                <signaturit-input
                    [isRequired]="field.required"
                    [inputType]="field.type"
                    [labelName]="field.label"
                    [inputWidth]="216"
                    [placeholderName]="field.placeholder"
                    (outputValue)="setInputValue($event, field.key, customFieldsForm)"
                >
                </signaturit-input>
                <mat-error *ngIf="showErrorMessage && customFieldsForm.get(field.key)?.hasError('required')">
                    {{ 'form_error_required' | translate }}
                </mat-error>
            </div>
        </form>
    </div>
    <div class="modal__actions">
        <signaturit-button
            [type]="'tertiary'"
            [size]="'md'"
            [text]="'cancel_text' | translate"
            (click)="closeModal()"
        >
        </signaturit-button>
        <signaturit-button
            [type]="'primary'"
            [size]="'md'"
            [text]="'confirm_text' | translate"
            (click)="onSubmit()"
        >
        </signaturit-button>
    </div>
</div>
